import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QlikVizPanel from '../qlik-viz-panel/QlikVizPanel';

interface ExpandDialogProps {
  open: boolean;
  onClose: () => void;
  qlikVizName: string;
  legendName?: string;
  enableInteractions?: boolean;
}

export const ExpandDialog: React.FC<ExpandDialogProps> = ({
  open,
  onClose,
  qlikVizName,
  legendName,
  enableInteractions = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    //   sx={{
    //     '& .MuiDialog-paper': {
    //       minHeight: '80vh',
    //       maxHeight: '90vh',
    //     },
    //   }}
    >
      {/* Close button */}
      {/* <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          color: 'grey.500',
        }}
      >
        <CloseIcon />
      </IconButton> */}

      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ borderTop: 3, borderColor: 'primary.main' }}>
          <QlikVizPanel
            qlikVizName={qlikVizName}
            legendName={legendName}
            enableInteractions={enableInteractions}
            inDialog={true}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ExpandDialog;